import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';

import ProposalLaySelection from '../../../../layouts/ProposalSelection/ProposalLaySelection';
import MainTitle from '../../../../components/MainTitle';
import MiniPagination from '../../../../components/MiniPagination';
import {
  loadProposalData,
  setProposalSelected,
} from '../../../../store/actions/ProposalsAction';
import './ProposalSelection.scss';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '2147483648 !important',
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: 530,
    //minHeight: 272,
    borderRadius: 4,
    padding: '16px 16px 16px 24px',
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
    },
  },
  root: {
    width: 200,
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const ProposalSelection = ({
  setStep,
  setCreateView,
  proposalData,
  valuesToEdit,
  loadProposalData,
  setProposalSelected,
}) => {
  const classes = useStyles();
  const smallMobile = useMediaQuery('(max-width: 1024px)');
  let [open, setOpen] = useState(false);
  let [boton, setBoton] = useState({ id: 0 });
  let [num, setNum] = useState(0);
  let [actualNum, setActualNum] = useState(0);
  let [arrayX, setArrayX] = useState([
    '/img/cotizacion/Temp1-Esmeralda.jpg',
    '/img/cotizacion/Temp4-Ascending_blue.jpg',
    '/img/cotizacion/Temp3-Onix.jpg',
  ]);

  const [elements, setElements] = useState([
    /*  { 
            id: 0,pathImg: '/img/cotizacion/Temp1-Esmeralda.jpg',
            portadas: ['/img/cotizacion/Temp1_Esmeralda/Temp1.jpg', '/img/cotizacion/Temp1_Esmeralda/Temp1-1.jpg' ,'/img/cotizacion/Temp1_Esmeralda/Temp1-2.jpg'],
            name: 'Esmeralda'},

        { id: 1,pathImg: '/img/cotizacion/Temp2-Ambar.jpg', 
            portadas: ['/img/cotizacion/Temp2_Ambar/Temp2.jpg', '/img/cotizacion/Temp2_Ambar/Temp2-1.jpg' ,'/img/cotizacion/Temp2_Ambar/Temp2-2.jpg'],
            name: 'Ambar'},

        { id: 2,pathImg: '/img/cotizacion/Temp3-Onix.jpg',
            portadas: ['/img/cotizacion/TEmp3_Onix/Temp3.jpg', '/img/cotizacion/TEmp3_Onix/Temp3-1.jpg' ,'/img/cotizacion/TEmp3_Onix/Temp3-2.jpg'],
            name: 'Onix'},

        { id: 3,pathImg: '/img/cotizacion/Temp4-Ascending_blue.jpg',
            portadas: ['/img/cotizacion/Temp4_Ascending/Temp4.jpg', '/img/cotizacion/Temp4_Ascending/Temp4-1.jpg' ,'/img/cotizacion/Temp4_Ascending/Temp4-2.jpg']
            ,name: 'Ascending'},

        { id: 4,pathImg: '/img/cotizacion/Temp5-Granada.jpg',
            portadas: ['/img/cotizacion/Temp5_Granada/Temp5.jpg', '/img/cotizacion/Temp5_Granada/Temp5-1.jpg' ,'/img/cotizacion/Temp5_Granada/Temp5-2.jpg'],
            name: 'Granada'},

        { id: 5,pathImg: '/img/cotizacion/Temp6-Zafiro.jpg',
            portadas: ['/img/cotizacion/Temp6_Zafiro/Temp6.jpg', '/img/cotizacion/Temp6_Zafiro/Temp6-1.jpg' ,'/img/cotizacion/Temp6_Zafiro/Temp6-2.jpg'],
            name: 'Zafiro'},

        { id: 6,pathImg: '/img/cotizacion/Temp7-Jade.jpg',
            portadas: ['/img/cotizacion/Temp7_Jade/Temp7.jpg', '/img/cotizacion/Temp7_Jade/Temp7-1.jpg' ,'/img/cotizacion/Temp7_Jade/Temp7-2.jpg'],
            name: 'Jade'},

        { id: 7,pathImg: '/img/cotizacion/Temp8-Agata.jpg',
            portadas: ['/img/cotizacion/Temp8_Agata/Temp8.jpg', '/img/cotizacion/Temp8_Agata/Temp8-1.jpg' ,'/img/cotizacion/Temp8_Agata/Temp8-2.jpg'],
            name: 'Agata'},

        { id: 8,pathImg: '/img/cotizacion/Temp9-Lazuli.jpg',
            portadas: ['/img/cotizacion/Temp9_Lazuli/Temp9.jpg', '/img/cotizacion/Temp8_Agata/Temp9-1.jpg' ,'/img/cotizacion/Temp8_Agata/Temp9-2.jpg'],
            name: 'Lazuli'},
            
        { id: 9,pathImg: '/img/cotizacion/Temp10-Obsidian.jpg',
            portadas: ['/img/cotizacion/Temp10_Obsidian/Temp10.jpg', '/img/cotizacion/Temp10_Obsidian/Temp10-1.jpg' ,'/img/cotizacion/Temp10_Obsidian/Temp10-2.jpg'],
            name: 'Obsidian'}, */

    {
      id: 0,
      pathImg: '/img/cotizacion/Temp11-Black.jpg',
      portadas: [
        '/img/cotizacion/Temp11_Black/Temp11.jpg',
        '/img/cotizacion/Temp11_Black/Temp11-1.jpg',
        '/img/cotizacion/Temp11_Black/Temp11-2.jpg',
      ],
      name: 'Black',
    },

    {
      id: 1,
      pathImg: '/img/cotizacion/Temp12-Professional.jpg',
      portadas: [
        '/img/cotizacion/Temp12_Professional/Temp12.jpg',
        '/img/cotizacion/Temp12_Professional/Temp12-1.jpg',
        '/img/cotizacion/Temp12_Professional/Temp12-2.jpg',
      ],
      name: 'Professional',
    },

    {
      id: 2,
      pathImg: '/img/cotizacion/Temp13-Light_blue.jpg',
      portadas: [
        '/img/cotizacion/Temp13_LightBlue/Temp13.jpg',
        '/img/cotizacion/Temp13_LightBlue/Temp13-1.jpg',
        '/img/cotizacion/Temp13_LightBlue/Temp13-2.jpg',
      ],
      name: 'LightBlue',
    },

    {
      id: 3,
      pathImg: '/img/cotizacion/Temp14-Ocean.jpg',
      portadas: [
        '/img/cotizacion/Temp14_Ocean/Temp14.jpg',
        '/img/cotizacion/Temp14_Ocean/Temp14-1.jpg',
        '/img/cotizacion/Temp14_Ocean/Temp14-2.jpg',
      ],
      name: 'Ocean',
    },

    {
      id: 4,
      pathImg: '/img/cotizacion/Temp15-Radiance.jpg',
      portadas: [
        '/img/cotizacion/Temp15_Radiance/Temp15.jpg',
        '/img/cotizacion/Temp15_Radiance/Temp15-1.jpg',
        '/img/cotizacion/Temp15_Radiance/Temp15-2.jpg',
      ],
      name: 'Radiance',
    },
  ]);

  function activar(id) {
    setBoton({ id: id });
    if (smallMobile) {
      handleOpen();
    }
  }

  const letfFunc = () => {
    if (actualNum > 0) {
      setActualNum(actualNum - 1);
    }
  };
  const rightFunc = () => {
    if (actualNum < 2) {
      setActualNum(actualNum + 1);
    }
  };
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  useEffect(() => {
    if (valuesToEdit && Object.values(valuesToEdit).length > 0) {
      setBoton({ id: valuesToEdit.templateId });
    }
    if (proposalData && Object.values(proposalData).length > 0) {
      setBoton({ id: proposalData.templateId });
    }
  }, []);

  const handleSubmit = () => {
    if (valuesToEdit && Object.values(valuesToEdit).length > 0) {
      console.log('edit');
      const newProposalData = {
        ...valuesToEdit,
        templateId: boton.id,
      };
      setProposalSelected(newProposalData);
    } else {
      console.log('create');
      const newProposalData = {
        ...proposalData,
        templateId: boton.id,
      };
      loadProposalData(newProposalData);
    }
    window.scroll(0, 0);
    setStep(1);
  };

  return (
    <section className="PS">
      <div style={{ marginBottom: 34 }}>
        <MainTitle
          title="Galería de plantillas"
          subtitle="Elige de la galería la plantilla que más se adapte a tu comodidad."
        />
      </div>
      <div className="PS-container">
        <ProposalLaySelection
          elements={elements}
          activar={activar}
          boton={boton}
          setStep={setStep}
          setCreateView={setCreateView}
          handleSubmit={handleSubmit}
        />

        <div className="PS-preview">
          <img
            style={{ width: '100%', height: 'auto' }}
            src={elements[boton.id].portadas[actualNum]}
            alt="portada"
          />

          <div className="PS-preview-pag">
            <MiniPagination
              color="blue"
              totalText={arrayX.length}
              actualNum={actualNum}
              total={arrayX.length - 1}
              letfFunc={letfFunc}
              rightFunc={rightFunc}
            />
          </div>
        </div>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className="PS-modal">
            <div class="PS-modal_close">
              <img
                onClick={handleClose}
                class="imgClose"
                src="/img/tache-white.svg"
                alt="close"
              />
            </div>
            <img
              style={{ width: '100%', height: 'auto' }}
              src={elements[boton.id].portadas[actualNum]}
              alt="portada"
            />

            <div className="PS-preview-pag">
              <MiniPagination
                color="white"
                actualNum={actualNum}
                total={arrayX.length - 1}
                totalText={arrayX.length}
                letfFunc={letfFunc}
                rightFunc={rightFunc}
              />
            </div>
          </div>
        </Fade>
      </Modal>
    </section>
  );
};
const mapStateToProps = (state) => ({
  proposalData: state.proposalsReducer.newProposalData,
  valuesToEdit: state.proposalsReducer.selectedProposal,
});

const mapDispatchToProps = (dispatch) => ({
  loadProposalData: (proposalData) => dispatch(loadProposalData(proposalData)),
  setProposalSelected: (proposalData) =>
    dispatch(setProposalSelected(proposalData)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ProposalSelection);
